// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__5qYyy","tip":"styles_tip__7YV_d","slideInSearchBar":"styles_slideInSearchBar__eanS9"};